<template>
  <div
    class="flex flex-col gap-8"
    :class="{
      'laptop:flex-row': props.row,
    }"
  >
    <template
      v-for="entry in props.news"
      :key="entry.id"
    >
      <template
        v-if="entry"
      >
        <NewsCard
          :news="entry"
          class="flex-1"
          :landscape="props.landscape"
        />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { News } from '~/composables/charon'

const props = defineProps<{
  landscape?: boolean
  row?: boolean
  news: News[]
}>()
</script>
